import React from 'react'
import { motion } from 'framer-motion'







const proofStats = [
  { value: '4+', label: 'Live Projects' },
  { value: '300+', label: 'DSA problems' },
  { value: 'MERN', label: 'Core stack' },
]

const strengths = [
  {
    title: 'React Development',
    description: 'Building responsive and user-friendly interfaces with React.',
  },
  {
    title: 'REST APIs',
    description: 'Developing secure and efficient APIs using Node.js and Express.',
  },
  {
    title: 'MongoDB',
    description: 'Designing databases for scalable and organized applications.',
  },
  {
    title: 'AWS & Docker',
    description: 'Learning cloud deployment and containerization fundamentals.',
  },
]

const EmailIcon = () => (
  <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
)

const LinkedInIcon = () => (
  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5ZM.5 8h4v16h-4V8Zm7 0h3.8v2.2h.1c.53-1 1.83-2.1 3.76-2.1 4.02 0 4.76 2.65 4.76 6.1V24h-4v-8.1c0-1.93-.04-4.42-2.69-4.42-2.7 0-3.11 2.1-3.11 4.28V24h-4V8Z" />
  </svg>
)

const GitHubIcon = () => (
  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.395-.135-.345-.72-1.395-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
  </svg>
)

const contactLinks = [
  { label: 'Email', href: 'mailto:omkarkardel175@gmail.com', icon: EmailIcon },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/omkar-kardel-96b855279', icon: LinkedInIcon },
  { label: 'GitHub', href: 'https://github.com/omkarkardel', icon: GitHubIcon },
]

const Hero = () => {
  const [scrollY, setScrollY] = React.useState(0)

  React.useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const parallaxOffset = scrollY * 0.12
  const bgOffset = scrollY * 0.04

  return (
    <section
      id="home"
      className="relative overflow-hidden scroll-mt-16 bg-slate-50 py-12 md:py-16 dark:bg-slate-950"
    >
      {/* Parallax background elements */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{ willChange: 'transform' }}>
        <div
          className="absolute -top-24 left-1/2 h-72 w-[38rem] -translate-x-1/2 rounded-full bg-cyan-500/10 blur-3xl"
          style={{ transform: `translate(-50%, ${bgOffset}px)` }}
        />
        <div
          className="absolute -bottom-32 right-[-10rem] h-80 w-80 rounded-full bg-emerald-400/10 blur-3xl"
          style={{ transform: `translateY(${-bgOffset}px)` }}
        />
      </div>

      <div className="relative mx-auto flex max-w-6xl flex-col items-center gap-10 px-4 md:flex-row md:gap-12 md:items-center md:justify-between">
        {/* Left column - text content */}
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="w-full md:max-w-xl"
          style={{ transform: `translateY(${parallaxOffset}px)`, willChange: 'transform' }}
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-medium text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-300">
            <span className="h-2 w-2 rounded-full bg-emerald-500" aria-hidden="true" />
            Available for internships and full-time roles
          </div>

          <h1 className="mt-5 max-w-2xl text-3xl font-bold leading-tight text-slate-950 sm:text-4xl lg:text-5xl dark:text-white">
            I build fast, scalable, and production-ready web applications.
          </h1>

          <p className="mt-5 text-lg font-medium text-primary">Omkar Kardel · Full Stack Developer</p>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-700 dark:text-slate-300">
            MERN Stack Developer building responsive web applications with React, Node.js, and MongoDB.
          </p>

          <div className="mt-6 grid grid-cols-3 gap-3">
            {proofStats.map((stat) => (
              <div key={stat.label} className="card-lift rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900/60">
                <p className="text-xl font-semibold text-slate-950 dark:text-white">{stat.value}</p>
                <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
            <motion.a
              whileHover={{ y: -2, boxShadow: '0 12px 30px rgba(37,99,235,0.25)' }}
              transition={{ type: 'spring', stiffness: 300, damping: 18 }}
              href="#contact"
              className="btn-hover inline-flex items-center justify-center rounded-xl bg-primary px-5 py-3 text-sm font-semibold text-white shadow-sm"
            >
              Reach Me Now
            </motion.a>

            <motion.a
              whileHover={{ y: -2 }}
              transition={{ type: 'spring', stiffness: 300, damping: 18 }}
              href="#projects"
              className="btn-hover inline-flex items-center justify-center rounded-xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-800 shadow-sm hover:border-primary dark:border-slate-700 dark:bg-slate-900/40 dark:text-white"
            >
              See My Work
            </motion.a>



          </div>

          <div className="mt-6 flex flex-wrap gap-2">
            {contactLinks.map((link) => {
              const Icon = link.icon

              return (
              <a
                key={link.label}
                href={link.href}
                target={link.href.startsWith('http') ? '_blank' : undefined}
                rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="btn-hover inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:border-primary hover:text-primary dark:border-slate-800 dark:bg-slate-900/60 dark:text-slate-200"
              >
                <Icon />
                {link.label}
              </a>
              )
            })}
          </div>
        </motion.div>

        {/* Right column - card with strengths */}
        <motion.div
          initial={{ opacity: 0, y: 22, scale: 0.98 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.65, delay: 0.08 }}
          className="relative w-full md:max-w-xl"
          style={{ willChange: 'transform' }}
        >
          <div className="absolute -inset-6 rounded-[2rem] bg-gradient-to-br from-cyan-500/20 via-blue-500/10 to-emerald-500/10 blur-2xl" aria-hidden="true" />

          <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white/80 shadow-xl shadow-slate-200/60 backdrop-blur dark:border-slate-800 dark:bg-slate-900/70 dark:shadow-black/20">
            <div className="p-6 md:p-7">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="text-xs font-medium uppercase tracking-wider text-primary">What I Build</p>
                  <h2 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">Building modern full-stack web applications</h2>
                </div>

                <div className="hidden rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-center shadow-sm dark:border-emerald-500/30 dark:bg-emerald-500/10 md:block">
                  <p className="text-[11px] font-semibold uppercase tracking-wider text-emerald-700 dark:text-emerald-300">Status</p>
                  <p className="mt-1 text-sm font-semibold text-slate-900 dark:text-white">Open to Internship</p>
                </div>
              </div>

              <div className="mt-5 grid grid-cols-2 gap-3">
                {strengths.map((item) => (
                  <div key={item.title} className="card-lift rounded-xl border border-slate-200 bg-slate-50 p-4 shadow-sm dark:border-slate-800 dark:bg-slate-950/40">
                    <p className="text-sm font-semibold text-slate-900 dark:text-white">{item.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-slate-600 dark:text-slate-300">{item.description}</p>
                  </div>
                ))}
              </div>

              <div className="mt-5 rounded-xl border border-slate-200 bg-white p-4 text-slate-900 shadow-sm dark:border-slate-700 dark:bg-slate-950 dark:text-white">
                <p className="text-xs font-semibold uppercase tracking-wider text-primary">Workflow</p>
                <ol className="mt-3 grid gap-3 sm:grid-cols-3">
                  <li className="flex items-center gap-3">
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 font-semibold text-primary dark:bg-white/10 dark:text-cyan-200">1</span>
                    <div>
                      <p className="text-sm font-semibold">Plan</p>
                      <p className="text-xs text-slate-600 dark:text-slate-300">Clarify goals</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3">
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 font-semibold text-primary dark:bg-white/10 dark:text-cyan-200">2</span>
                    <div>
                      <p className="text-sm font-semibold">Build</p>
                      <p className="text-xs text-slate-600 dark:text-slate-300">Write clean code</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3">
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 font-semibold text-primary dark:bg-white/10 dark:text-cyan-200">3</span>
                    <div>
                      <p className="text-sm font-semibold">Launch</p>
                      <p className="text-xs text-slate-600 dark:text-slate-300">Deploy confidently</p>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Hero
